import React, { createContext, useState, useEffect } from "react";
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import auth from "../Layout/util/auth";
export const Context = createContext({});
export const Provider = (props) => {
  const [paymentSuccessModel, setPaymentSuccessModel] = useState(false);
  const [sourcePaymentFlow, setSourcePaymentFlow] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);
  const [fantigerCoin, setFantigerCoin] = useState(0);
  const [mobileUpdated, setMobileUpdated] = useState(false);
  const [socket, setSocket] = useState(null);
  const [socketId, setSocketId] = useState("");
  const [maxCoin, setMaxCoin] = useState(20);
  const [calculator, setCalculator] = useState(false);
  const [normalcalculator, setNormalcalculator] = useState(false);
  const CommonContext = {
    paymentSuccessModel,
    setPaymentSuccessModel,
    setSourcePaymentFlow,
    sourcePaymentFlow,
    walletBalance,
    setWalletBalance,
    fantigerCoin,
    setFantigerCoin,
    setMobileUpdated,
    mobileUpdated,
    socket,
    setSocket,
    socketId,
    setSocketId,
    maxCoin,
    setMaxCoin,
    calculator,
    setCalculator,
    normalcalculator,
    setNormalcalculator,
  };

  useEffect(() => {
    const r = auth();
    if (r.token != null) GetWalletblance();
  }, []);

  const { mutate: GetWalletblance } = useMutation(
    () => fetcher.get(`v1/wallet/balance`),
    {
      onSuccess: (res) => {
        console.log("🚀 ~ file: index.js ~ line 110 ~ LoginForm ~ res", res);
        CommonContext.setWalletBalance(res?.balance);
        CommonContext.setFantigerCoin(res?.fantigerCoin || 0);
        CommonContext.setMaxCoin(res?.fantigerCoinRedeemPercentage || 20);
        if (typeof window !== "undefined") {
          localStorage.setItem("walletBalance", res.balance);
        }
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  const { value } = props;
  return (
    <Context.Provider
      value={{
        paymentSuccessModel: paymentSuccessModel,
        setPaymentSuccessModel: setPaymentSuccessModel,
        sourcePaymentFlow: sourcePaymentFlow,
        setSourcePaymentFlow: setSourcePaymentFlow,
        walletBalance: walletBalance,
        fantigerCoin: fantigerCoin,
        setFantigerCoin: setFantigerCoin,
        setWalletBalance: setWalletBalance,
        mobileUpdated: mobileUpdated,
        setMobileUpdated: setMobileUpdated,
        socket: socket,
        setSocket: setSocket,
        socketId: socketId,
        setSocketId: setSocketId,
        maxCoin: maxCoin,
        setMaxCoin: setMaxCoin,
        calculator: calculator,
        setCalculator: setCalculator,
        normalcalculator: normalcalculator,
        setNormalcalculator: setNormalcalculator,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export const { Consumer } = Context;

export {
  Context as CommonContext,
  Provider as CommonContextProvider,
} from "./commonContext";
